import React from "react";
import PageHero from "../components/PageHero";
import { TrendingUp, Briefcase, Users, Award, Building2, Target } from "lucide-react";
import { AnimatedCounter } from "../components/AnimatedCounter";

const companies = [
  "Maruti Suzuki", "Honda", "Becton Dickenson", "Stryker", "IFB", "Subros",
  "Asahi Glass", "Denso", "Faurecia", "Mitsubishi Electric", "PPAP", "Daifuku",
  "Dantal", "Nifco", "Bridgestone", "Mahindra",
];

export default function PlacementPage() {
  return (
    <>
      <PageHero
        path="placement.hero"
        kicker="Student Placement"
        title="Industry-ready talent, global-ready careers"
        subtitle="Our graduates work at India's top manufacturing companies and global multinationals. 95%+ placement track record speaks for itself."
      />
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid sm:grid-cols-2 lg:grid-cols-4 gap-6 text-center">
          {[
            { icon: Users, value: 5000, suffix: "+", label: "Students Placed" },
            { icon: Building2, value: 60, suffix: "+", label: "Hiring Partners" },
            { icon: TrendingUp, value: 95, suffix: "%", label: "Placement Rate" },
            { icon: Award, value: 25, suffix: "+", label: "Years Track Record" },
          ].map((it, i) => (
            <div key={i} className="bg-white rounded-2xl p-7 shadow-sm border border-slate-100 tilt-card">
              <div className="h-14 w-14 rounded-2xl bg-yellow-400/15 mx-auto mb-4 flex items-center justify-center">
                <it.icon className="h-7 w-7 text-yellow-600" />
              </div>
              <div className="text-4xl font-bold text-[#0B2A6B]">
                <AnimatedCounter value={it.value} suffix={it.suffix} />
              </div>
              <p className="text-sm text-slate-600 mt-1">{it.label}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="py-16 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10">
            <p className="kicker mb-3">Our recruiters</p>
            <h2 className="text-3xl font-bold text-[#0B2A6B]">Where our students work</h2>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {companies.map((c, i) => (
              <div key={c} className="bg-white rounded-xl px-4 py-6 shadow-sm border border-slate-100 text-center font-bold text-[#0B2A6B] hover:bg-yellow-400 hover:text-[#0B2A6B] transition tilt-card">
                {c}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10">
            <p className="kicker mb-3">How we place</p>
            <h2 className="text-3xl font-bold text-[#0B2A6B]">Our 4-step placement process</h2>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {[
              { step: 1, icon: Target, title: "Skill Assessment", desc: "Identify each student's strengths and growth areas." },
              { step: 2, icon: Briefcase, title: "Industry Match", desc: "Match students to companies based on fit and aptitude." },
              { step: 3, icon: Users, title: "Interview Prep", desc: "Mock interviews, CV building and soft skills training." },
              { step: 4, icon: Award, title: "Placement", desc: "On-campus interviews leading to job offers." },
            ].map((s) => (
              <div key={s.step} className="relative bg-white rounded-2xl p-6 border border-slate-100 shadow-sm">
                <div className="absolute -top-3 -right-3 h-9 w-9 rounded-full bg-yellow-400 text-[#0B2A6B] font-bold flex items-center justify-center">
                  {s.step}
                </div>
                <s.icon className="h-8 w-8 text-[#0B2A6B] mb-3" />
                <h3 className="font-bold text-[#0B2A6B] mb-1">{s.title}</h3>
                <p className="text-sm text-slate-600">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
